import { useIdle } from 'react-use';

import { useSelectUserIdleDuration } from '../widgetManager';

export const useIsIdle = () => {
  const idleTimeout = useSelectUserIdleDuration();
  return useIdle(idleTimeout);
};
